import React from "react";

export default function RouteLoading() {
  return (
    <div className="route-loading" role="status" aria-live="polite">
      <span className="route-loading__spinner" aria-hidden="true"></span>
      <span>Loading...</span>
    </div>
  );
}
